import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Romina S.',
  age: 34,
  location: 'Córdoba',
  text: 'Siempre sentí que el Reiki era para mí, pero no encontraba un material claro. El MegaPack me dio la estructura que necesitaba. Ahora practico todos los días con confianza.'
}, {
  name: 'Gabriela M.',
  age: 42,
  location: 'Rosario',
  text: 'Tenía miedo de no entender nada, pero todo está explicado tan simple que desde el primer tomo ya estaba practicando. Mis dolores de cabeza crónicos mejoraron muchísimo.'
}, {
  name: 'Soledad P.',
  age: 38,
  location: 'Buenos Aires',
  text: 'Lo compré pensando que era otro curso más, pero me sorprendió la profundidad y la claridad. Mis hijos notan la diferencia en casa. Estoy más tranquila y presente.'
}, {
  name: 'Mariana L.',
  age: 51,
  location: 'Mendoza',
  text: 'A mi edad pensé que era tarde para empezar algo nuevo. El MegaPack me demostró lo contrario. Hoy doy sesiones a mis amigas y me siento realizada.'
}, {
  name: 'Florencia R.',
  age: 29,
  location: 'La Plata',
  text: 'Soy muy escéptica pero decidí probar. La guía de chakras fue reveladora. Entendí cosas de mi cuerpo y emociones que nunca había conectado.'
}];
export function TestimonialsSection() {
  return <section className="bg-gray-50 py-20 md:py-28 px-4" data-id="element-188">
      <div className="container mx-auto max-w-4xl" data-id="element-189">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold text-gray-900 text-center mb-14 leading-tight" data-id="element-190">
          Lo que dicen quienes ya lo tienen
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-191">
          {TESTIMONIALS.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className={`bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100 ${idx === TESTIMONIALS.length - 1 ? 'md:col-span-2 md:max-w-lg md:mx-auto' : ''}`} data-id="element-192">
              <div className="flex gap-0.5 mb-4" data-id="element-193">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-194" />)}
              </div>
              <p className="text-gray-600 text-base leading-relaxed mb-5 italic" data-id="element-195">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-196">
                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white font-bold text-xs" data-id="element-197">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-198">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-199">
                    {t.name}, {t.age} años
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-200">
                    {t.location}, Argentina
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}